/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable max-len */
import React, { useState } from 'react';
import PropTypes from 'prop-types';

const ShareModal = ({
  title,
  url,
  videoNetworkId,
  videoId,
}) => {
  const icons = [
    {
      name: 'facebook',
      shareUrl: `https://www.facebook.com/sharer/sharer.php?u=${url}`,
    },
    {
      name: 'twitter',
      shareUrl: `https://twitter.com/intent/tweet?url=${url}`,
    },
    {
      name: 'email',
      shareUrl: `mailto:?body=${title} ${url}`,
    },
    {
      name: 'embed',
      shareUrl: '#',
    },
  ];

  const [showMessage, setShowMessage] = useState(false);

  const handleSocialButtonClick = (type, shareUrl) => {
    if ('embed' === type) {
      const vidEmbedCode = `<script type="text/javascript" charset="UTF-8" src="${window.location.protocol}//${nbc.currentDomain}/portableplayer/?CID=${videoNetworkId}&videoID=${videoId}&origin=${nbc.host}&fullWidth=y"></script>`;

      const tempTextArea = document.createElement('textarea');

      tempTextArea.value = vidEmbedCode;
      document.body.appendChild(tempTextArea);
      tempTextArea.select();
      document.execCommand('copy');

      setShowMessage(true);

      setTimeout(() => {
        setShowMessage(false);
      }, 3000);

      document.body.removeChild(tempTextArea);
    } else {
      window.open(`${shareUrl}`);
    }
  };

  const hideShareModal = () => {
    document.querySelector('.modal').classList.toggle('active');
  };

  return (
    <div className="share-modal">
      <h3 className="share-modal-title">Share this story</h3>
      <p className={`share-modal-message ${! showMessage ? 'is-hidden' : ''}`}>Copied to clipboard</p>
      <div className="share-modal-icons">
        {
          icons.map(({ name, shareUrl }) => {
            if (
              'embed' === name &&
              '' === videoId &&
              '' === videoNetworkId
            ) {
              return null;
            }

            return (
              <a
                className={`share-modal-icon ${name}`}
                target="_blank"
                href={url}
                onClick={(e) => {
                  e.preventDefault();
                  handleSocialButtonClick(name, shareUrl);
                }}
                rel="noreferrer"
              >
                {name}
              </a>
            );
          })
        }
      </div>
      <button
        className="share-modal-cancel"
        onClick={() => { hideShareModal(); }}
        type="button"
      >
        Cancel
      </button>
    </div>
  );
};

ShareModal.defaultProps = {
  title: '',
  url: '',
  videoNetworkId: '',
  videoId: '',
};

ShareModal.propTypes = {
  title: PropTypes.string,
  url: PropTypes.string,
  videoNetworkId: PropTypes.string,
  videoId: PropTypes.string,
};

export default ShareModal;
